import * as React from "react";
import { mergeStyleSets, nuOrderTheme as theme, Icon, Text } from "@nuorder/components";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";

const emptyListStyles = mergeStyleSets({
    emptyListContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        margin: "60px auto",
        minWidth: "450px",
    },
    emptyListIcon: {
        fill: theme.palette.neutralTertiary,
    },
    emptyListTitle: {
        fontSize: "20px",
        fontWeight: "600",
        marginTop: "7px",
    },
    emptyListContent: {
        marginTop: "6px",
        textAlign: "center",
    },
});

export const EmptyView = () => {
    return (
        <div
            data-test={DATATEST.ASSORTMENTS.FOOTER.MANAGE_TARGETS.EMPTY_VIEW}
            className={emptyListStyles.emptyListContainer}
        >
            <Icon iconName={"folder64"} className={emptyListStyles.emptyListIcon} />
            <Text className={emptyListStyles.emptyListTitle}>{formatMessage("No targets yet")}</Text>
            <Text className={emptyListStyles.emptyListContent}>
                {formatMessage("Create targets to validate buying decisions directly in NuORDER.")}
            </Text>
        </div>
    );
};
